import React from 'react';
import { Translate } from '@pegasus/translation';
import { Title, TitlePreset, FunctionColor, Tag } from '@lux/title';
import { StyledSectionTitleWrapper } from './styles';

const SectionTitle = ({ message, tag }: { message: string; tag?: Tag }) => (
    <StyledSectionTitleWrapper>
        <Title preset={TitlePreset.S} color={FunctionColor.function100} tag={tag}>
            <Translate message={message} />
        </Title>
    </StyledSectionTitleWrapper>
);

export default SectionTitle;
